/** Contatori ROL / Ex festività: input centesimale a 3 decimali, indipendente dal formato durate aziendale. */
import React, { useEffect, useState } from "react";
import { Input } from "@/components/ui/input";
import { formatCounterHours, parseCounterHours } from "@/lib/counterHours";

export function CounterHoursInput({ value, onCommit, "data-testid": testid, ...rest }) {
  const shown = formatCounterHours(value || 0);
  const [text, setText] = useState(shown);
  const [error, setError] = useState(false);
  useEffect(() => { setText(shown); setError(false); }, [shown]);
  const commit = () => {
    if (text === shown) return; // invariato: conserva il valore interno a 6 decimali
    const n = parseCounterHours(text);
    if (n === null) { setError(true); return; }
    setError(false);
    onCommit(n);
    setText(formatCounterHours(n));
  };
  return (
    <Input {...rest} inputMode="decimal" value={text} data-testid={testid} aria-invalid={error || undefined}
      className={`font-mono ${error ? "border-suite-error" : ""}`} placeholder="0,000"
      onChange={(e) => setText(e.target.value)} onBlur={commit}
      onKeyDown={(e) => { if (e.key === "Enter") commit(); }} />
  );
}

export default CounterHoursInput;
